














































import { defineComponent, ref, useContext, onMounted, watch } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import MarketingCard from './MarketingCard.vue';
import { getAxiosConfigs } from '~/utils/solepro/functions';
import axios from 'axios';
import { useConfig } from '~/composables';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { getFirstPriceLabel, getSecondPriceLabel } from '~/utils/helpers/product';

import { Pagination, Navigation } from 'swiper'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import ConfigureBundle from '~/components/solepro/ProductPage/PurchaseOptions/ConfigureBundle.vue';
SwiperCore.use([Pagination, Navigation])
import ClientOnly from 'vue-client-only';
import { equalizePurchaseSlides, observeScalapay } from '~/utils/helpers/solepro/product';
import PaymentMethodsIcons from '~/components/solepro/ProductPage/PaymentMethodsIcons.vue';
import { SIMPLE_TYPE_ID, TIPO_RINNOVO_AUTOMATICO, VIRTUAL_TYPE_ID } from '~/utils/constants/product';


export default defineComponent({
  props: {
    node: {
      type: Object as PropType<ProductForProductPageType>,
      required: true
    },
    showFrequencies: {
      type: Boolean,
      default: true
    }
  },
  components: {
    MarketingCard,
    ConfigureBundle,
    Swiper,
    SwiperSlide,
    ClientOnly,
    PaymentMethodsIcons
  },
  data() {
    return {
      isSSR: true,
      swiperInstance: null
    }
  },
  setup(props) {
    const { node: content } = props as Readonly<{ [key: string]: any }>;
    const hasFrequencies = ref(false);
    const { app, $fc } = useContext();
    const { config } = useConfig();
    const products = ref<ProductForProductPageType[]>([]);
    const paymentFrequenciesChoosen = ref({});
    const cardsQty = ref(0);

    const swiperProps = {
      modules: [Navigation, Pagination],
      slideClass: "slide",
      spaceBetween: 20,
      navigation: {
        prevEl: '.section-purchase-options .navigation-prev',
        nextEl: '.section-purchase-options .navigation-next',
      },
      pagination: false,
      slidesPerView: 3,
      slidesPerGroup: 3,
      direction: "horizontal",
      loop: false,
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          freeMode: true,
          navigation: false,
          allowTouchMove: true,
          grabCursor: false,
          direction: "vertical",
        },
        1024: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          direction: "horizontal",
          allowTouchMove: true,
          grabCursor: true,
          freeMode: false,
        }
      },
    };

    const fetchProducts = async () => {
      if (content) {
        const skus = content.skus ? content.skus : content.children[0].skus
        try {
          const { data } = await axios.post(`/sole-api/product/pro/getPacchetti`, { skus }, { ...getAxiosConfigs(app, config) });
          products.value = data as ProductForProductPageType[];
          cardsQty.value = products.value.length;
          
          products.value.forEach(product => {
            paymentFrequenciesChoosen.value[product.sku] = product.entryBillingPeriod ?? product.paymentFrequencies[product.paymentFrequencies.length - 1];
          });
        } catch (error) {
          console.error("Errore nel recupero dei pacchetti:", error);
        }
      }
    };

    // Chiama la funzione di fetch immediatamente
    fetchProducts();
    
    // Aggiungi un watcher per richiamare la fetch se le props cambiano
    watch(() => props.node, fetchProducts, { immediate: true });


    return {
      products,
      swiperProps,
      paymentFrequenciesChoosen,
      i18n: app.i18n, fc: $fc,
      hasFrequencies,
      cardsQty,
      cssClasses: content.cssClasses.join(' ') || '',
    };
  },
  mounted() {
    this.isSSR = false  
  },
  methods: {
    // I tuoi metodi rimangono invariati
    setHasFrequencies(val: boolean) {
      this.hasFrequencies = this.hasFrequencies || val;
    },
    
    afterInit(swiper: any) {
      this.swiperInstance = swiper;
      observeScalapay(swiper.$el[0], () => setTimeout(() => equalizePurchaseSlides(swiper, false), 100));
      setTimeout(() => {
        equalizePurchaseSlides(swiper);
      }, 100);
    },
    getFirstPriceLabelProp(product: ProductForProductPageType) {
      return getFirstPriceLabel(product, this.paymentFrequenciesChoosen[product.sku], this.i18n, this.fc);
    },
    getSecondPriceLabelProp(product: ProductForProductPageType) {
      const isVirtualRecurring = (product.tipo_rinnovo == TIPO_RINNOVO_AUTOMATICO  && (product.productTypeId ==  VIRTUAL_TYPE_ID || product.productTypeId ==  SIMPLE_TYPE_ID))
      return getSecondPriceLabel(product, this.paymentFrequenciesChoosen[product.sku], this.i18n, this.fc, 0, 0, isVirtualRecurring );
    },
    changeFrequency(product: ProductForProductPageType, val: any) {
      this.paymentFrequenciesChoosen[product.sku] = val;
      this.$forceUpdate();
    },
    onSwiperResize(swiper: any) {
      equalizePurchaseSlides(swiper);
      console.log('swiper resized');
    },
  },
})
